import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import { EmailsApi } from '@eventbrite/auth-lib';

import {
    SOFT_ACCOUNT_SEND_EMAIL_FAILED,
    LOGIN_SOFT_ACCOUNT,
} from '../constants/messages';
import { GA_EVENTBRITE, GA_FACEBOOK, GA_APPLE } from '../constants/analytics';
import { SOFT_ACCOUNT_EMAIL_STATUSES } from '../constants/status';

import {
    trackSoftAccountMailFailed,
    trackSoftAccountMailSent,
} from './gaTracking';

import { showAuthNotification, clearAuthNotification } from './auth';

/**  ACTION CREATORS  **/
export const SET_SOFT_ACCOUNT_EMAIL_STATUS = 'SET_SOFT_ACCOUNT_EMAIL_STATUS';
export const setSoftAccountEmailStatus = (payload) => ({
    type: SET_SOFT_ACCOUNT_EMAIL_STATUS,
    payload,
});

/**  ACTIONS  **/
/**
 * Sends email activation for Soft Account
 */
export const sendSoftAccountEmail = () => (dispatch, getState) => {
    const state = getState();

    const {
        authentication: { email, referrer } = {},
        social: { socialProvider },
    } = state;
    let sourceProvider = GA_EVENTBRITE;

    if (!isEmpty(socialProvider)) {
        sourceProvider = socialProvider;
    }

    dispatch(clearAuthNotification());
    dispatch(setSoftAccountEmailStatus(SOFT_ACCOUNT_EMAIL_STATUSES.ongoing));
    return EmailsApi.sendSoftAccountActivationEmail({
        email,
        destination: referrer,
    })
        .then(() => {
            dispatch(
                setSoftAccountEmailStatus(
                    SOFT_ACCOUNT_EMAIL_STATUSES.delivered,
                ),
            );
            dispatch(
                showAuthNotification({
                    message: LOGIN_SOFT_ACCOUNT.replace('{email}', email),
                    iconType: null,
                }),
            );
            trackSoftAccountMailSent({
                sourceProvider,
                state,
            });
        })

        .catch((error) => {
            dispatch(
                setSoftAccountEmailStatus(SOFT_ACCOUNT_EMAIL_STATUSES.failed),
            );
            dispatch(
                showAuthNotification({
                    message: SOFT_ACCOUNT_SEND_EMAIL_FAILED,
                    iconType: null,
                }),
            );
            return trackSoftAccountMailFailed({
                errorMessage: get(
                    error,
                    'response.parsedError.error',
                    get(error, 'response.statusText', 'Error not defined'),
                ),
                state,
            });
        });
};
